import api from '@src/utils/api';
import intlTelInput from 'intl-tel-input';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, Field } from 'theme-ui';

const ContactForm = () => {
  const { t } = useTranslation();
  const telref = useRef<HTMLElement | null>(null);
  const [refVisible, setRefVisible] = useState(false);
  const [countryCodeInput, setCountryCodeInput] = useState<intlTelInput | null>(
    null
  );
  const [queryMessage, setQueryMessage] = useState('');
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    if (!refVisible) {
      return;
    }

    const input = (telref.current as HTMLElement)?.querySelector('input');

    const preferredCountries: any = [];
    if (process.env.GATSBY_DEFAULT_LANGUAGE) {
      preferredCountries.push(process.env.GATSBY_DEFAULT_LANGUAGE);
    }
    const ini = intlTelInput(input, {
      // any initialisation options go here
      preferredCountries: preferredCountries,
      separateDialCode: true,
      formatOnDisplay: false,
      customPlaceholder: () => '',
      utilsScript:
        'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
    });

    // Format phone number on change
    input?.addEventListener('input', () => {
      const a = ini.getSelectedCountryData();
      ini.setNumber(
        input.value?.startsWith('+')
          ? input.value
          : `+${a.dialCode}${input.value}`
      );
    });

    setCountryCodeInput(ini);
  }, [refVisible]);

  const handleOnSubmit = async (data) => {
    const phone = countryCodeInput.getNumber(
      intlTelInputUtils.numberFormat.E164
    );
    const dto = {
      name: data.name,
      phone_number: phone,
    };
    try {
      const response = await api.post('public/educationExpertQuery', dto);
      if (response.success) {
        setQueryMessage(t('querySuccess'));
      } else {
        setQueryMessage(t('queryError'));
      }
    } catch (error) {
      setQueryMessage(t('queryError'));
    }
  };
  const checkPhone = async () => {
    const isValidPhoneNumber = countryCodeInput?.isValidNumber();
    if (!isValidPhoneNumber) {
      return t('invalidPhoneNumber');
    }
  };
  function testPhone() {
    return !countryCodeInput.isValidNumber() && !countryCodeInput.telInput.value
      ? t('fieldRequired')
      : t('invalidPhoneNumber');
  }
  return (
    <Box
      sx={{
        padding: ['15px', '34px 0 50px 0'],
        borderRadius: ['0 0 20px 20px', '0 0 38px 38px'],
        backgroundColor: '#ffffff',
        zIndex: 2,
      }}
    >
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: ['1fr', '2fr  2fr 1fr'],
            gap: '16px',
            alignItems: 'baseline',
            padding: [' 0', '0 200px'],
          }}
        >
          <Box className="labels-on-inputs">
            <Field
              label={t('name')}
              placeholder={t('yourName')}
              className={errors.name ? 'field-error' : ''}
              {...register('name', {
                required: true,
              })}
            />
            {errors.name && (
              <span sx={{ color: 'error' }}>{t('fieldRequired')}</span>
            )}
          </Box>

          <Box
            className="labels-on-inputs"
            ref={(el) => {
              telref.current = el;
              setRefVisible(!!el);
            }}
          >
            <Field
              label={t('phoneN')}
              type="tel"
              className={errors.phone ? 'field-error' : ''}
              {...register('phone', {
                required: true,
                validate: () => checkPhone(),
              })}
            />
            {errors.phone && <span sx={{ color: 'error' }}>{testPhone()}</span>}
          </Box>
          <Box
            sx={{ alignSelf: errors.phone || errors.name ? 'center' : 'end' }}
          >
            <Button type="submit" sx={{ width: ['100%', 'auto'] }}>
              {t('send')}
            </Button>
          </Box>
        </Box>
      </form>
      {queryMessage && (
        <Box
          sx={{
            textAlign: ['start', 'center'],
            paddingTop: '20px',
            fontSize: '20px',
            animation: 'fadeIn 0.5s',
          }}
        >
          {queryMessage}
        </Box>
      )}
    </Box>
  );
};

export default ContactForm;
